export const environment = {
  production: false,
  // taf_base_url: "https://kom-com.sentech.online/taf/",
    taf_base_url: "https://kodi.harmattan-gs.com/taf/",
  public_share_base_url: "https://koom.sn",
};

